import React, { Fragment, useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  CustomerRanking,
  KindCustomer,
  KindSeller,
  MethodOfIntroduction,
  PurchasePosibility,
} from "../../data/crmGeneralData";
import {
  useFilterCrmFile,
  useGetBrands,
  useGetCategory,
  useGetCities,
  useGetCustomer,
  useGetGroupingData,
  useGetMarketer,
} from "../../hooks/useCrm";
import { IdUser } from "../../services/apiConfig";
import { advancedSearch } from "../../shared/advancedSearch";
import { crmFilteredData } from "../../shared/crm-filter";
import { pageNumber } from "../../shared/crmAdvancedSearchPageNumber";
import { formatDate } from "../../utils/formatDate";
import { DataPicker } from "../DataPicker/DataPicker";
import { SelectMulti } from "../MultiSelect/MultiSelect";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";

export const AdvancedSearchFilterBar = () => {
  const [form, setForm] = useRecoilState(advancedSearch);
  const NumberPage = useRecoilValue(pageNumber);
  const { data: customerresponsible } = useGetCustomer();
  const { data: cities } = useGetCities();
  const { data: marketer } = useGetMarketer();
  const { data: cat } = useGetCategory();
  const { data: brands } = useGetBrands();
  const name = localStorage.getItem("profile")
    ? JSON.parse(localStorage.getItem("profile")).users[0]
    : null;
  useEffect(() => {
    if (name?.Status !== "admin") {
      setForm({ ...form, IdResponsible: IdUser });
    }
  }, [IdUser]);

  const { data: FilteredData, refetch } = useFilterCrmFile(
    {
      ...form,
      IdResponsible: form.IdResponsible ? form.IdResponsible : "",
    },
    NumberPage
  );

  useEffect(() => {
    refetch();
  }, [form]);
  const [data, setData] = useRecoilState(crmFilteredData);
  const { data: grouping } = useGetGroupingData();
  const methodOfIntroduction =
    grouping?.data?.groping_new_user_crms[0]?.methodOfIntroduction?.map(
      (item) => {
        return {
          value: item.ContentGroping,
          label: item.ContentGroping,
        };
      }
    );
  const rankingCustomer =
    grouping?.data?.groping_new_user_crms[0]?.RankingCustomer?.map((item) => {
      return {
        value: item.ContentGroping,
        label: item.ContentGroping,
      };
    });
  const kindSeller = grouping?.data?.groping_new_user_crms[0]?.KindSeller?.map(
    (item) => {
      return {
        value: item.ContentGroping,
        label: item.ContentGroping,
      };
    }
  );
  // useEffect(() => {
  //   refetch();
  // }, [form]);
  useEffect(() => {
    setData(FilteredData);
  }, [FilteredData]);
  useEffect(() => {
    if (NumberPage >= 1) {
      refetch();
    }
  }, [NumberPage]);

  const inputRef = null;
  const customerResponsible = customerresponsible?.data?.Colleague;
  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });
  const Cities = cities?.data?.ProvincesAndCities;
  const CitiesOptions = Cities?.map((city) => {
    return {
      value: city.IdCities,
      label: city.NameProvinces + "-" + city.NameCities,
    };
  });

  const KindCustomerOptions = KindCustomer.map((method) => {
    return {
      value: method.value,
      label: method.label,
    };
  });

  const Marketers = marketer?.data?.Marketer;
  const MarketersOptions = Marketers?.map((mark) => {
    return {
      value: mark.IdUser,
      label: mark.FirstName + " " + mark.LastName,
    };
  });
  const PurchasePosibilityOptions = PurchasePosibility?.map((mark) => {
    return {
      value: mark.value,
      label: mark.label,
    };
  });
  const categories = cat?.data?.categories;
  const categoriesOptions = categories?.map((cat) => {
    return {
      value: cat.NameCategories,
      label: cat.NameCategories,
    };
  });
  const Brands = brands?.data?.brands;
  const BrandsOptions = Brands?.map((brand) => {
    return {
      value: brand.IdBrands,
      label: brand.NameBrands,
    };
  });
  console.log(form);
  return (
    <Fragment>
      <div className="row">
        <div className="col-12">
          <SimpleSelect1
            label="مسئول"
            placeholder="انتخاب مسئول"
            res={customerResponsibleOptions}
            onChange={(e) => {
              if (!e) {
                e = {
                  target: inputRef,
                  value: "",
                };
              }
              setForm({ ...form, IdResponsible: e.value });
            }}
            IsScroll={true}
          />
        </div>
        <div className="col-12">
          <SimpleSelect1
            label="شهر"
            placeholder="انتخاب شهر"
            onChange={(e) => {
              if (!e) {
                e = {
                  target: inputRef,
                  value: "",
                };
              }
              setForm({ ...form, IdIdCities: e.value });
            }}
            res={CitiesOptions}
            IsScroll={true}
          />
        </div>
        <div className="col-12">
          <SimpleSelect1
            label="رتبه بندی مشتری"
            placeholder="انتخاب رتبه بندی مشتری"
            res={rankingCustomer}
            onChange={(e) => {
              if (!e) {
                e = {
                  target: inputRef,
                  value: "",
                };
              }
              setForm({ ...form, RankingCustomer: e.value });
            }}
            IsScroll={true}
          />
        </div>
        <div className="col-12">
          <SimpleSelect1
            label="نحوه آشنایی"
            placeholder="انتخاب نحوه آشنایی"
            res={methodOfIntroduction}
            onChange={(e) => {
              if (!e) {
                e = {
                  target: inputRef,
                  value: "",
                };
              }
              setForm({ ...form, methodOfIntroduction: e.value });
            }}
            IsScroll={true}
          />
        </div>
        <div className="col-12">
          <SimpleSelect1
            label="وضعیت شخص"
            placeholder="انتخاب نوع شخص"
            res={KindCustomerOptions}
            onChange={(e) => {
              if (!e) {
                e = {
                  target: inputRef,
                  value: "",
                };
              }
              setForm({ ...form, KindCustomer: e.value });
            }}
            IsScroll={true}
          />
        </div>
        <div className="col-12">
          <SimpleSelect1
            label="نوع فروش"
            placeholder="انتخاب نوع فروش"
            res={kindSeller}
            onChange={(e) => {
              if (!e) {
                e = {
                  target: inputRef,
                  value: "",
                };
              }
              setForm({ ...form, KindSeller: e.value });
            }}
            IsScroll={true}
          />
        </div>
        <div className="col-12">
          <SimpleSelect1
            label="لیست بازاریابان"
            placeholder="انتخاب بازاریاب"
            res={MarketersOptions}
            onChange={(e) => {
              if (!e) {
                e = {
                  target: inputRef,
                  value: "",
                };
              }
              setForm({ ...form, IdMarketer: e.value });
            }}
            IsScroll={true}
          />
        </div>
        <div className="col-12">
          <SimpleSelect1
            label="احتمال خرید"
            placeholder="انتخاب احتمال خرید"
            res={PurchasePosibilityOptions}
            onChange={(e) => {
              if (!e) {
                e = {
                  target: inputRef,
                  value: "",
                };
              }
              setForm({ ...form, ProbabilityOfPurchase: e.value });
            }}
            IsScroll={true}
          />
        </div>
        <div className="col-12">
          <SelectMulti
            label="دسته بندی محصولات"
            placeholder="انتخاب دسته بندی محصولات"
            res={categoriesOptions}
            onChange={(e) => {
              if (!e) {
                e = {
                  target: inputRef,
                  value: "",
                };
              }
              setForm({
                ...form,
                NameCategory: Array.isArray(e)
                  ? e.map((x) => x.value).join(",")
                  : [],
              });
            }}
            IsScroll={true}
          />
        </div>
        <div className="col-12">
          <SelectMulti
            label="لیست برندها"
            placeholder="انتخاب برند"
            res={BrandsOptions}
            onChange={(e) => {
              if (!e) {
                e = {
                  target: inputRef,
                  value: "",
                };
              }
              setForm({
                ...form,
                BrandCategory: Array.isArray(e)
                  ? e.map((x) => x.label).join(",")
                  : [],
              });
            }}
            IsScroll={true}
          />
        </div>
        <div className="col-6">
          <DataPicker
            label="از تاریخ"
            onChange={(e) => setForm({ ...form, Start: formatDate(e) })}
          />
        </div>
        <div className="col-6">
          <DataPicker
            label="تا تاریخ"
            onChange={(e) => setForm({ ...form, End: formatDate(e) })}
          />
        </div>
      </div>
    </Fragment>
  );
};
